import React, { useState, useEffect } from 'react';
import { Tag, Image } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import NoxTable from '../../component/Table';
import InnerHeader from '../../component/InnerHeader';
import { fetchAllComments, removeComment } from '../../actions/CommentsAction';

import Copy from '../../component/Copy';
import formatDate from '../../helpers/formatDate';

const Comments = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const dispatch = useDispatch();
  const history = useHistory();

  const comments = useSelector(({ comment }) => comment.comments);
  const currentProject = useSelector(({ project }) => project.currentProject);

  const openDetail = (commentId) => {
    history.push(`/ecommerce/comments/${commentId}`);
  };

  const columns = [
    {
      dataIndex: 'link',
      key: 'link',
      render: (link) => (
        <Image
          height={40}
          src={link}
          style={{ borderRadius: '6px', objectFit: 'fill' }}
          width={40}
        />
      ),
      title: 'Preview'
    },
    {
      dataIndex: 'id',
      key: 'id',
      render: (id) => {
        return <Copy text={id} />;
      },
      sorter: (a, b) => a.id.localeCompare(b.id),
      title: 'Comment ID'
    },
    {
      dataIndex: 'comment',
      key: 'comment',
      render: (comment) => {
        return <Copy text={comment} />;
      },
      sorter: (a, b) => a.comment.localeCompare(b.comment),
      title: 'Comment'
    },
    {
      dataIndex: 'name',
      key: 'name',
      render: (name) => {
        return <Copy text={name} />;
      },
      sorter: (a, b) => a.name.localeCompare(b.name),
      title: 'Author'
    },
    {
      dataIndex: 'date',
      key: 'date',
      render: (date) => {
        return <Copy text={date} />;
      },
      sorter: (a, b) => new Date(a.date) - new Date(b.date),
      title: 'Date & Time'
    },
    {
      dataIndex: 'reply',
      key: 'reply',
      render: (reply) => {
        return <Copy text={reply} />;
      },
      sorter: (a, b) => a.reply.localeCompare(b.reply),
      title: 'Reply'
    },
    {
      key: 'edit',
      render: (comment) => {
        return <Tag onClick={() => openDetail(comment.id)}>View</Tag>;
      }
    }
  ];

  const mapToTable = (comments) => {
    const data = [];

    if (!comments || !comments.length) {
      return data;
    }

    comments.forEach(({ _id, item, text, createdAt, profile, replyComment }, index) => {
      data.push({
        comment: text,
        date: formatDate(createdAt),
        id: _id,
        key: index,
        link: item?.imageUrl,
        name: `@${profile?.userName}`,
        reply: replyComment ? '1 Reply' : '0 Reply'
      });
    });

    return data;
  };

  const onItemDelete = () => {
    selectedRowKeys.forEach((index) => {
      const item = data[index];

      dispatch(
        removeComment(currentProject._id, item?.id, () => {
          dispatch(fetchAllComments());
        })
      );
    });

    setSelectedRowKeys([]);
  };

  useEffect(() => {
    async function load() {
      dispatch(fetchAllComments());
    }

    if (currentProject) {
      load();
    }
  }, [currentProject, dispatch]);

  const isLoaded = useSelector(({ comment }) => comment.isLoaded);
  const data = mapToTable(comments);

  const actions = [
    {
      // onClick: onDownload,
      disabled: false,

      title: 'Download CSV',

      type: 'primary'
    }
  ];

  if (selectedRowKeys.length) {
    actions.unshift({
      onClick: onItemDelete,
      title: 'Delete',
      type: 'secondary'
    });
  }

  return (
    <div
      style={{
        height: 'calc(100vh - 165px)',
        overflowY: 'scroll'
      }}
    >
      <InnerHeader subtitle={comments.length} title="Comments" />
      <NoxTable
        actions={actions}
        columns={columns}
        data={data}
        loading={!isLoaded}
        searchBy="name"
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
      />
    </div>
  );
};

export default Comments;
